export default __webpack_public_path__ + "static/media/icon-delete.1fd1f1f7.svg";